// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"2accf254","112":"534d3bd2","552":"84726dc3"}[chunkId] + ".chunk.css";
};